import { render, staticRenderFns } from "./Download2.vue?vue&type=template&id=179e63d0&"
import script from "./Download2.vue?vue&type=script&lang=js&"
export * from "./Download2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports